import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

interface AuthContextType {
  isAuthenticated: boolean
  login: (credentials: string) => void
  logout: () => void
  credentials: string | null
}

const AuthContext = createContext<AuthContextType | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [credentials, setCredentials] = useState<string | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    // 从 localStorage 恢复认证状态
    const savedCredentials = localStorage.getItem('auth')
    if (savedCredentials) {
      setCredentials(savedCredentials)
    }
  }, [])

  const login = (newCredentials: string) => {
    setCredentials(newCredentials)
    localStorage.setItem('auth', newCredentials)
  }

  const logout = () => {
    setCredentials(null)
    localStorage.removeItem('auth')
    navigate('/login')
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!credentials,
        login,
        logout,
        credentials
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
} 